/**
 * @desc 查询目录根节点
 */
import {
  NewsCatalogueEntity,
  NewsCatalogueRootQuery
} from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryNewsCatalogueRootListParameter = NewsCatalogueRootQuery

const method = 'GET'
const url = '/content/mall/news/catalogue/root'

export const queryNewsCatalogueRootListApi = (
  params?: QueryNewsCatalogueRootListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<NewsCatalogueEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryNewsCatalogueRootListApi.method = method
queryNewsCatalogueRootListApi.url = url
